import React, { useState } from "react";
// import './Login.css'
import tocaroLogo from '../assets/tocaroLogo.webp'
import { getCsrfToken } from '../utils/auth';
import { useUser } from "../contexts/UserContext";

const Login = ({ sessionToken }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false)
    const { setAdmin, setUser, setCompany } = useUser()

    const handleLogin = async (e) => {
        e.preventDefault();

        setError('');

        try {
            const reqBody = JSON.stringify({ username, password })
            const loginResult = await fetch(`/api/back4app/login`, {
                method: 'POST',
                body: reqBody,
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': getCsrfToken()
                },
                credentials: 'include',
            })

            const res = await loginResult.json();
            if (loginResult.ok && res.user && res.user.company) {
                setUser(true);
                setCompany(res.user.company);
                if (res.user.company === 'admin') {
                    setAdmin(true);
                } else {
                    setAdmin(false);
                }
                setError('');
            } else {
                setUser(null);
                setAdmin(false);
                setCompany(null);
                setError(res.error || 'Invalid username or password');
            }

        } catch(error){
            const res = await fetch(`/api/logout`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': getCsrfToken()
                }
            });

            if (!res.ok) {
                const err = await res.json().catch(() => ({}));
                throw new Error(err.error || err.msg || 'Logout failed');
            }

            // localStorage.removeItem('currentUser');
            // localStorage.removeItem('sessionToken');
            
            setUser(null);
            setAdmin(false);
            setError('Invalid username or password');
            console.error('Error logging in: ', error);
        };
      };
    return(
        <div className="
        flex h-screen w-screen flex-col items-center justify-center bg-white relative overflow-hidden
        motion-reduce:animate-none
      ">
            <img
        src={tocaroLogo}
        alt="Tocaro Blue"
        className="
          w-[400px] md:w-[400px] max-w-[65vw] mb-8 drop-shadow-md
          animate-fade-in-down motion-reduce:animate-none
        "
      />
            
            <div
        className="
          w-[min(400px,90%)] rounded-2xl border border-[rgba(34,30,91,0.10)]
          bg-[rgba(34,30,91,0.05)] backdrop-blur-[20px]
          p-10 shadow-login z-10
          animate-fade-in-up motion-reduce:animate-none
          md:p-10 sm:p-6
        "
      >
                <h2 className="pb-6 text-center text-[1.875rem] font-light text-gray-800">
                DevKit Dashboard
            </h2>

                <form onSubmit={handleLogin} className="flex w-full flex-col gap-6">
                    <div className="relative flex items-center">
                        <input
                            className="
                h-[50px] w-full rounded-[12px]
                border-2 border-[rgba(34,30,91,0.20)]
                bg-white/90 px-4 pr-12 text-[16px] text-[#333]
                placeholder:text-[rgba(34,30,91,0.50)]
                backdrop-blur-[10px]
                outline-none transition
                focus:border-[#221E5B] focus:bg-white
                focus:[box-shadow:0_0_0_3px_rgba(34,30,91,0.10)]
                focus:-translate-y-[1px]
                sm:h-[48px] sm:text-[16px]
              "
                            id="username"
                            type="text"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div className="relative flex items-center">
                        <input
                            className="
                h-[50px] w-full rounded-[12px]
                border-2 border-[rgba(34,30,91,0.20)]
                bg-white/90 px-4 pr-10 text-[16px] text-[#333]
                placeholder:text-[rgba(34,30,91,0.50)]
                backdrop-blur-[10px]
                outline-none transition
                focus:border-[#221E5B] focus:bg-white
                focus:[box-shadow:0_0_0_3px_rgba(34,30,91,0.10)]
                focus:-translate-y-[1px]
                sm:h-[48px]
              "
                            id="password"
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                       <button
                            type="button"
                            className="
                absolute right-2 top-1/2 -translate-y-1/2
                rounded-md p-2 text-[rgba(34,30,91,0.60)]
                transition hover:bg-black/5
              "
                            onClick={() => setShowPassword(!showPassword)}
                            >
                            {showPassword ? (
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                                <circle cx="12" cy="12" r="3"/>
                                </svg>
                            ) : (
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                                <line x1="1" y1="1" x2="23" y2="23"/>
                                </svg>
                            ) }
                        </button>
                    </div>
                        <button type="submit" className="
              relative h-[50px] w-full rounded-[12px]
              text-white font-semibold uppercase tracking-[0.5px]
              transition overflow-hidden
              bg-[linear-gradient(135deg,#221E5B_0%,#1a1745_100%)]
              hover:-translate-y-[2px] hover:shadow-btnHover
              active:translate-y-0 active:shadow-btnActive
              group
              motion-reduce:transition-none
              before:content-[''] before:absolute before:inset-y-0 before:left-[-100%]
              before:w-full before:bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.2),transparent)]
              before:transition-[left] before:duration-500
              hover:before:left-[100%]
            ">Sign In</button>
                </form>
                {error && (
                    <p className="pt-4 text-center italic text-red-600" style={{ 
                        color: 'red',
                        textAlign: 'center',
                        fontStyle: 'italic',
                        paddingTop: '1rem'
                    }}>
                        {error}
                    </p>
                    )}
            </div>
            <h3 className="mt-4 font-normal">
  Forgot your login? {' '}
  <a 
    href="mailto:tech@tocaroblue.com"
    className="cursor-pointer underline text-blue-500 transition-colors hover:text-blue-700"
  >
     Contact Us
  </a>
</h3>
        </div>
    );
};

export default Login;